import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Fetches the homepage config and returns the shop_by_price sub-config.
 * Cached in module scope so multiple pages don't re-fetch on every mount.
 */
let _cached = null;

export function useShopByPriceConfig() {
  const [config, setConfig] = useState(_cached);

  useEffect(() => {
    if (_cached) { setConfig(_cached); return; }
    axios.get(`${API}/homepage`).then(res => {
      const sbp = res.data?.shop_by_price || null;
      _cached = sbp;
      setConfig(sbp);
    }).catch(() => {});
  }, []);

  return config;
}
